// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__2NyER","wrapper":"Form_wrapper__1pEgi","input":"Form_input__9zIIX","button":"Form_button__2IG1r"};